// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "../styles/navbar.css";
// import logo from "../assets/images/logoTransparent.png";

// export default function Navbar() {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   const NavbarTitle = [
//     { label: "Home", type: "scroll", id: "home" },
//     { label: "Features", type: "scroll", id: "features" },
//     { label: "Our Products", type: "scroll", id: "products" },
//     { label: "FAQs", type: "scroll", id: "faqs" },
//   ];

//   return (
//     <nav className="navbar">
//       <img src={logo} alt="logo" className="navbar-logo" />

//       <div
//         className={`menu-icon ${menuOpen ? "open" : ""}`}
//         onClick={() => setMenuOpen(!menuOpen)}
//       >
//         <span></span><span></span><span></span>
//       </div>

//       <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
//         {NavbarTitle.map((item) => (
//           // <li
//           //   key={item.label}
//           //   onClick={() => {
//           //     setMenuOpen(false);
//           //     if (item.type === "scroll") {
//           //       document.getElementById(item.id).scrollIntoView({ behavior: "smooth" });
//           //     } else {
//           //       navigate(item.path);
//           //     }
//           //   }}
//           // >
//           //   {item.label}
//           // </li>
//           <li
//             key={item.label}
//             onClick={() => {
//               setMenuOpen(false);

//               if (item.type === "scroll") {
//                 if (window.location.pathname !== "/") {
//                   // navigate to home first
//                   navigate("/", { state: { scrollTo: item.id } });
//                 } else {
//                   // already on home → directly scroll
//                   document.getElementById(item.id)?.scrollIntoView({ behavior: "smooth" });
//                 }
//               } else {
//                 navigate(item.path);
//               }
//             }}
//           >
//             {item.label}
//           </li>

//         ))}
//       </ul>

//       <button className="navbar-btn">Sign Up</button>
//     </nav>
//   );
// }


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/navbar.css";
import logo from "../assets/images/logoTransparent.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // Change on scroll
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const NavbarTitle = [
    { label: "Home", type: "scroll", id: "home" },
    { label: "Features", type: "scroll", id: "features" },
    { label: "Our Products", type: "scroll", id: "products" },
    { label: "FAQs", type: "scroll", id: "faqs" },
  ];

  return (
    <nav className={`navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      <img src={logo} alt="logo" className="navbar-logo" />

      <div
        className={`menu-icon ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span><span></span><span></span>
      </div>

      <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
        {NavbarTitle.map((item) => (
          <li  className={`menu-heading ${scrolled ? "menu-heading-scrolled" : ""}`}
            key={item.label}
            onClick={() => {
              setMenuOpen(false);
              if (item.type === "scroll") {
                if (window.location.pathname !== "/") {
                  navigate("/", { state: { scrollTo: item.id } });
                } else {
                  document.getElementById(item.id)?.scrollIntoView({ behavior: "smooth" });
                }
              } else {
                navigate(item.path);
              }
            }}
          >
            {item.label}
          </li>
        ))}
      </ul>

      {/* <button className="navbar-btn">Sign Up</button> */}
    </nav>
  );
}
